import { compareAsc } from "./dateTime"

export const sortByTextAttribute =
  <T>(attributeName: keyof T) =>
  (itemA: T, itemB: T): number => {
    if (typeof itemA[attributeName] !== "string" || typeof itemB[attributeName] !== "string")
      return 0

    const value_a = (itemA[attributeName] as string).toLowerCase()
    const value_b = (itemB[attributeName] as string).toLowerCase()

    return value_a < value_b ? -1 : value_a > value_b ? 1 : 0
  }

export const sortByDateField = (fieldName: string) => (a: any, b: any) =>
  compareAsc(a[fieldName], b[fieldName])

export const sortByStartDate = sortByDateField("start")
